module.exports = BD.Model.extend({
    taxRate: BD.belongsTo('Billy.TaxRate', { isParent: true }),
    share: BD.attr('number'),
    source: BD.attr('string'),
    account: BD.belongsTo('Billy.Account'),
    priority: BD.attr('number')
})
